/**
 * Pure routing decision for the Anna app's cold-start profile check.
 *
 * When the authoritative server read of `drivers/{uid}` comes back WITHOUT
 * registration fields, we must decide: is this a genuine new driver who should
 * see the registration form, or a verified driver who hit a transient / relink
 * race and should stay on the dashboard?
 *
 * Rule: only route to registration when there is NO verified-complete profile
 * for this uid anywhere (neither in React state nor in the per-uid local cache).
 * A driver already marked `ready`, or holding a complete profile, is never sent
 * back to registration by a single incomplete read — the live listener will
 * re-confirm. This is what stops the "registration form flashes over the
 * dashboard on every cold open" bug.
 *
 * CommonJS so `node --test` can load it with no build step (matches the
 * firebase/functions test convention); webpack imports it from ESM fine.
 *
 * @param {string} currentStatus   the current profileStatus
 * @param {boolean} hasVerifiedProfile  a complete profile exists in state or the per-uid cache
 * @returns {'ready'|'refreshing-profile'|'new-driver'}
 */
const nextStatusForIncompleteProfile = (currentStatus, hasVerifiedProfile) => {
  if (currentStatus === 'ready') return 'ready';
  if (hasVerifiedProfile) return 'refreshing-profile';
  return 'new-driver';
};

module.exports = { nextStatusForIncompleteProfile };
